
import { Component, Mixins } from "vue-property-decorator";
import { CoachScoutingReportMixin } from "@/mixins";
import RadarChartJS from "@/components/charts/RadarChartJS.vue";
import ScoutingReportMatrixV3 from "@/components/scoutingReport/ScoutingReportMatrixV3.vue";
import { Route } from 'vue-router';

@Component({
	components: {
		RadarChartJS,
		ScoutingReportMatrixV3,
	},
	
})

export default class ViewScoutingReport extends Mixins(CoachScoutingReportMixin){
	// from mixin CoachScoutingReportMixin:
	// 	@Prop() reportId: string;
	// 	@Prop() athleteId: string;
	
	ScoutingLabel(name: string, length: number = 6): string {
		if( this.IsEmpty(name) ) return '-';

		const keywords = ['Tactical', 'Technical', 'Mental', 'Physical']
		const lowerKeywords = keywords.map(k => k.toLowerCase());
		const trimmedName = name.trim();

		// Case-insensitive match with keyword
		if (lowerKeywords.includes(trimmedName.toLowerCase())) {
			return trimmedName;
		}

		// Name is short enough
		if (trimmedName.length < 9) {
			return trimmedName;
		}

		// Name has multiple words → return acronym
		const words = trimmedName.split(/\s+/);
		if (words.length > 1) {
			return words.map(w => w[0].toUpperCase()).join('');
		}

		// Fallback → return first N letters
		return trimmedName.substring(0, length);
	}

	viewAthleteRoute(athleteId: string): Partial<Route>{
		return {
			name: "CoachViewAthlete",
			params:{
				athleteId
			}
		}
	}

  }

